// closing-misc-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1c.postRef': '(post {code})',
  'r1c.addSuffix': '-post',
  'r1c.incomeBalanceNote': 'Ved å endre tall her vil ikke dette påvirke selve regnskapet ditt, kun skattemeldingen. Er regnskapet ditt feil må du gjenåpne regnskapet og korrigere det før du oppretter et nytt utkast av skattemeldingen.',
});
